<script setup lang="ts">
  const { mode } = defineProps<{
    mode: "signin" | "submissionLock";
  }>();
</script>

<template>
  <section
    class="mx-auto flex max-w-4xl items-center justify-center"
    :class="mode == 'signin' ? 'sm:px-4 md:h-dvh' : ''"
  >
    <div
      class="grid rounded-lg border border-gray-300 shadow-lg md:grid-cols-2"
    >
      <div
        class="relative flex min-h-48 items-center justify-center bg-blue-950 sm:min-h-96 sm:max-md:rounded-t-lg md:rounded-l-lg"
      >
        <div class="absolute inset-0">
          <img
            src="~/assets/images/spiral.png"
            alt=""
            class="h-full w-full object-cover opacity-20"
          />
        </div>
        <div class="z-10 flex flex-col items-center">
          <img
            src="~/assets/images/word-logo.png"
            alt="Relief Insights"
            class="size-20"
          />
        </div>
      </div>
      <slot name="form" :mode="mode" />
    </div>
  </section>
</template>
